import React from 'react';

// Renders the Creator Registration page design (self-contained HTML in /public/register.html).
// The form posts directly to /api/register via an injected script.
export default function RegisterPage() {
  return (
    <iframe
      src="/register.html"
      title="Creator Registration — Talesverse"
      data-testid="register-frame"
      style={{ position: 'fixed', inset: 0, width: '100%', height: '100%', border: 'none', display: 'block' }}
    />
  );
}
